import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "@/pages/post/components/carReportSection/CarReportSection.module.css";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
var CarReportDisclaimerPopUp = function CarReportDisclaimerPopUp(_ref) {
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation(["web_post_view"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SharedPopUp, {
    show: true,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.ms2olyenPopUpCR
  }, /*#__PURE__*/React.createElement("strong", null, t("disclaimer", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("p", null, /*@fixme: to strapi*/t("car_maintenance_repair_depend_condition", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("p", null, /*@fixme: to strapi*/t("report_mean_way_adhere_condition", {
    ns: "web_post_view"
  }))));
};
export default CarReportDisclaimerPopUp;